import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Stack, Alert } from '@mui/material';

export default function Electricity() {
    const [building, setBuilding] = useState('');
    const [roomNumber, setRoomNumber] = useState('');
    const [room, setRoom] = useState();
    const [showAlert, setShowAlert] = useState(false);
    const [openDialog, setOpenDialog] = useState(false);
    const [performPayment, setPerformPayment] = useState(false);
    const [amountInput, setAmountInput] = useState('');
    const [record, setRecord] = useState('');
    const [roomListing, setRoomListing] = useState([]);
    const [previous3MonthData, setPrevious3MonthData] = useState('');
    const [roomNotFoundError, setRoomNotFoundError] = useState('');
    const [indexOfRoomNumber, setIndexOfRoomNumber] = useState(0);
    
    // Alert message
    const [alertVisible, setAlertVisible] = useState(false);
    const [alertMessage, setAlertMessage] = useState('');
    const [alertSeverity, setAlertSeverity] = useState('success');

    const [inputMethod, setInputMethod] = useState('keyboard');
    
    const handleBuildingClick = (letter) => {
      setBuilding(letter);
      setOpenDialog(false);
    };
  
    const handleRoomNumberClick = (number) => {
      setRoomNumber(prevRoomNumber => {
        if (prevRoomNumber.length < 2) {
            setOpenDialog(false);
          return prevRoomNumber + number;
        }
        return prevRoomNumber;
      });
    };

    useEffect(() => {
        if (inputMethod === 'keyboard') {
            const handleKeyPress = (e) => {
                if (!performPayment) {
                    // Building input (A-Z)
                    if (/^[A-Za-z]$/.test(e.key) && !building) {
                        const upperKey = e.key.toUpperCase();
                        if (['A', 'B', 'C', 'D', 'H', 'K', 'N', 'R'].includes(upperKey)) {
                            setBuilding(upperKey);
                        }
                    }
                    // Room number input (0-9)
                    else if (/^[0-9]$/.test(e.key) && building && roomNumber.length < 2) {
                        setRoomNumber(prev => prev + e.key);
                    }
                } else {
                    // Amount input for payment screen
                    if (/^[0-9]$/.test(e.key)) {
                        setAmountInput(prev => prev + e.key);
                    }
                }
            };

            const handleBackspace = (e) => {
                if (e.key === 'Backspace') {
                    if (performPayment) {
                        setAmountInput(prev => prev.slice(0, -1));
                    } else if (roomNumber) {
                        setRoomNumber(prev => prev.slice(0, -1));
                    } else if (building) {
                        setBuilding('');
                    }
                }
            };

            window.addEventListener('keypress', handleKeyPress);
            window.addEventListener('keydown', handleBackspace);

            return () => {
                window.removeEventListener('keypress', handleKeyPress);
                window.removeEventListener('keydown', handleBackspace);
            };
        }
    }, [inputMethod, building, roomNumber, performPayment]);

    const handleRoomSubmit = async (roomToSubmit) => {
        try {
            const response = await fetch(`${process.env.REACT_APP_API_ENDPOINT}/electricity/room-electricity-data?room_number=${roomToSubmit}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            });
    
            if (!response.ok) {
                const errorData = await response.json();
                setOpenDialog(true);
                setRoomNotFoundError(errorData.message);
                throw new Error(errorData.message);
            }
    
            const data = await response.json();
            setPrevious3MonthData(data);
            setPerformPayment(true);
            setIndexOfRoomNumber(roomListing.indexOf(roomToSubmit));
        } catch (err) {
            console.error(err.message);
        }
    };

    const handleRoomSubmitClick = (e) => {
        e.preventDefault();
        if (!building || !roomNumber) {
            setOpenDialog(true); // Open the dialog if validation fails
        } else {
            let room_number = building + roomNumber;
            setRoom(room_number);
            handleRoomSubmit(room_number);
        }
    }
  
    const handleResetRoomNumber = () => {
      setRoomNumber('');
    };

    const handleDialogClose = () => {
        setOpenDialog(false);
    };

    const [currency, setCurrency] = useState('USD'); // default to USD

    const handleButtonClick = (value) => {
        setAmountInput((prevInput) => prevInput + value);
    };
  
    const handleDelete = () => {
        setAmountInput((prevInput) => prevInput.slice(0, -1));
    };
  
    const handlePaymentSubmit = () => {
      // Submit the input value to the API
      const data = { amount: amountInput, currency };
      console.log('Submitting data to API:', data);
  
    };
    
    const handleArrowBack = () => {
        setPerformPayment(false);
        setAmountInput('');
    }

    // ========================================>> API fetching
    const fetchRoomList = async() => {
        try {
            const response = await fetch(`${process.env.REACT_APP_API_ENDPOINT}/water-usage/room-listing`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            });

            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.message || 'Failed to fetch room.');
            }

            const room = await response.json();
            setRoomListing(room);
        } catch (err) {
            console.error(err.message);
        }
    }
    

    useEffect(() => {
        fetchRoomList();
    }, []);

    const handleDataSubmit = () => {
        if (!amountInput) {
            setOpenDialog(true);
            setRoomNotFoundError("សូមបញ្ចូលតម្លៃប្រើប្រាស់អស់");
            return;
        }

        const dataTobeSubmitted = {
            room_number: `${room}`,
            amount: `${amountInput}`
        }

        fetch(`${process.env.REACT_APP_API_ENDPOINT}/electricity`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('token')}`,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(dataTobeSubmitted),
        })
        .then((response) => {
            if (!response.ok) {
                return response.json().then((data) => {
                    setAlertMessage(data.message);
                    setAlertSeverity("error");
                    setAlertVisible(true);
                    setTimeout(() => {
                        setAlertVisible(false);
                    }, 2000);
                    throw data;
                })
            }
            return response.json();
        })
        .then(() => {
            setAlertMessage(`ទិន្នន័យត្រូវបានបញ្ចូលជោគជ័យ`);
            setAlertSeverity("success");    
            setAlertVisible(true);
            handleArrowChangeRoom("forward");
            setAmountInput("");
            setTimeout(() => {
                setAlertVisible(false);
            }, 2000);
        })
        .catch((error) => {
            setAlertMessage(error.message);
            setAlertSeverity("error");
            setAlertVisible(true);
            setTimeout(() => {
                setAlertVisible(false);
            }, 2000);
        })
    }

    const handleArrowChangeRoom = (action) => {
        let newIndex;
        if (action === "forward" && indexOfRoomNumber !== roomListing.length - 1) {
            newIndex = indexOfRoomNumber + 1;
        } else if (action === "backward" && indexOfRoomNumber !== 0) {
            newIndex = indexOfRoomNumber - 1;
        } else {
            return; // Exit if no valid move
        }
    
        // Update state in one go
        setIndexOfRoomNumber(newIndex);
        const new_room_number = roomListing[newIndex];
        setRoom(new_room_number);
        handleRoomSubmit(new_room_number);
        setAmountInput("");
    }

    const InputMethodToggle = () => (
        <div className="flex justify-center ml-2 md:ml-10">
            <div className="bg-white rounded-lg shadow-md p-2">
                <button
                    onClick={() => setInputMethod('button')}
                    className={`px-2 md:px-4 py-2 rounded-l-lg md:text-lg ${inputMethod === 'button' ? 'bg-secondary1 text-white' : 'bg-gray-200'}`}
                >
                    ប្រើប៊ូតុង
                </button>
                <button
                    onClick={() => setInputMethod('keyboard')}
                    className={`px-2 md:px-4 py-2 rounded-r-lg md:text-lg ${inputMethod === 'keyboard' ? 'bg-secondary1 text-white' : 'bg-gray-200'}`}
                >
                    ប្រើក្តារចុច
                </button>
            </div>
        </div>
    );

    return (
        <div className="w-full h-[100dvh] bg-white">
            {/* Header */}
            <div className="w-full h-[8dvh] bg-primary2 text-white flex  items-center">
                <div className="md:w-[8%] pl-3 md:pl-10 items-center flex">
                    {!performPayment ? (
                    <NavLink to='/electricity-report'>
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-12">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M6.75 15.75 3 12m0 0 3.75-3.75M3 12h18" />
                        </svg>
                    </NavLink>) : (
                        <button onClick={handleArrowBack}>
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-12">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M6.75 15.75 3 12m0 0 3.75-3.75M3 12h18" />
                        </svg>
                    </button>
                    )}
                </div>
                <div className="w-[84%] flex justify-center">
                    <h2 className="text-2xl font-semibold">ទិន្នន័យភ្លើង</h2>
                </div>
            </div>

            {/* Body */}
            {!performPayment ? (
            <div className="w-full flex flex-col md:px-16 justify-center items-center">
                <div className="w-full text-start flex items-center my-3 md:mt-5 md:mb-0 md:pl-7">
                    <h2 className="text-base sm:text-xl pl-2 md:pl-5 md:text-2xl font-medium md:mt-4 md:my-4 flex"><span className="hidden sm:flex">ជ្រើសរើស</span>បន្ទប់</h2>
                    <div className="text-xl md:text-2xl font-medium border w-[40%] md:w-[60%] ml-2 md:ml-10 py-2 border-[#d9d9d9] px-5 rounded-lg h-12"><strong>{building}{roomNumber}</strong></div>
                    <InputMethodToggle/>
                </div>
                <div className="lg:w-[90%] flex justify-center xl:w-[80%]">
                    <form onSubmit={handleRoomSubmit} className="space-y-8 w-full">
                        <div className="flex flex-col md:flex-row justify-center items-center md:items-stretch space-y-5 md:space-y-0 md:space-x-8 w-full md:mt-3">
                        {/* Building Selection */}
                        <div className="text-center md:mr-7 w-[70%] md:w-[50%] xl:w-[40%] border-2 py-3 md:py-5 flex flex-col items-center md:items-stretch md:pl-5 lg:pl-10 pr-2 shadow-custom-shadow rounded-lg">
                            <h3 className="text-xl md:text-3xl 2xl:text-2xl font-semibold mb-3 md:mb-8">អគារ</h3>
                            <div className="grid grid-cols-3 gap-6">
                            {['A', 'B', 'C', 'D', 'H', 'K', 'N', 'R'].map((letter) => (
                                <button
                                type="button"
                                key={letter}
                                onClick={() => handleBuildingClick(letter)}
                                className={`w-12 h-12 md:w-16 md:h-16 lg:w-20 lg:h-20 2xl:h-[4.5rem] font-medium rounded-lg lg:rounded-2xl border border-gray-300 text-2xl flex items-center justify-center ${
                                    building === letter ? 'bg-secondary1' : 'bg-gray-300'
                                }`}
                                >
                                {letter}
                                </button>
                            ))}
                            </div>
                        </div>

                        {/* Room Number Selection */}
                        <div className="text-center w-[70%] md:w-[50%] xl:w-[40%] border-2 py-3 md:py-5 flex flex-col items-center md:items-stretch md:pl-5 lg:pl-10 pr-2 shadow-custom-shadow rounded-lg">
                            <h3 className="text-xl md:text-3xl 2xl:text-2xl font-semibold mb-3 md:mb-8">បន្ទប់</h3>
                            <div className="grid grid-cols-3 gap-6">
                            {[1, 2, 3, 4, 5, 6, 7, 8, 9].map((number) => (
                                <button
                                type="button"
                                key={number}
                                onClick={() => handleRoomNumberClick(number.toString())}
                                className={`w-12 h-12 md:w-16 md:h-16 lg:w-20 lg:h-20 2xl:h-[4.5rem] text-3xl font-medium rounded-lg lg:rounded-2xl border border-gray-300 flex items-center justify-center ${
                                    roomNumber.includes(number.toString()) ? 'bg-secondary1' : 'bg-gray-300'
                                }`}
                                >
                                {number}
                                </button>
                            ))}
                            </div>
                            <div className="grid grid-cols-3 gap-4 mt-6">
                                <div></div>
                            {[0].map((number) => (
                                <button
                                type="button"
                                key={number}
                                onClick={() => handleRoomNumberClick(number.toString())}
                                className={`w-12 h-12 md:w-16 md:h-16 lg:w-20 lg:h-20 2xl:h-[4.5rem] text-3xl rounded-lg lg:rounded-2xl border border-gray-300 flex items-center justify-center ${
                                    roomNumber.includes(number.toString()) ? 'bg-secondary1' : 'bg-gray-300'
                                }`}
                                >
                                {number}
                                </button>
                            ))}
                            </div>
                        </div>
                        </div>

                        {/* Selected Building and Room */}
                        {/* <div className="text-center space-y-4">
                            <p className="text-xl font-medium">បន្ទប់ដែលបានជ្រើសរើស៖ <strong>{building}{roomNumber}</strong></p>
                        </div> */}

                        {/* Submit Button */}
                        <div className="text-center flex justify-center">
                            <button
                                type="button"
                                onClick={handleResetRoomNumber}
                                className="px-8 md:px-16 py-1 md:py-4 text-base md:text-2xl font-medium bg-gray-200 text-gray-800 rounded-lg hover:bg-gray-300 mr-4"
                            >
                                ជ្រើសរើសបន្ទប់ឡើងវិញ
                            </button>
                            <button
                                type="submit"
                                className="px-14 md:px-28 py-1 md:py-4 text-base md:text-2xl font-medium bg-secondary1 text-white  rounded-lg hover:bg-primary2"
                                onClick={handleRoomSubmitClick}
                            >
                                បន្ទាប់
                            </button>
                                    
                        </div>
                    </form>
                </div>
            </div>) : (
            <div className="flex flex-col items-center py-5 md:pt-10 md:pb-0 md:px-4">
                
                <div className="flex flex-row w-full md:w-[70%] mb-6 pl-7 px-4 md:px-0">
                    {/* Left Side Building Prices */}
                    <div className="bg-white md:px-4 py-3 md:py-6 rounded-md shadow-md w-[60%] md:w-48 lg:w-[35%] xl:w-[30%] sm:flex sm:flex-col border-2 mr-auto">
                        <h3 className="text-center font-semibold mb-4 md:text-xl">ប្រវត្តិប្រើប្រាស់</h3>
                        <ul className="text-left ml-5 space-y-2 md:text-xl font-medium">
                            {previous3MonthData.length > 0 && 
                                previous3MonthData.map((data) => (
                                    <li key={data.monthYear}>ខែទី {data.monthYear.slice(0, -4)} = {Number(data.currentRecorded).toLocaleString('en-US')}៛</li>
                                ))
                            }
                        </ul>
                    </div>

                    {/* Right Side Room Information */}
                    <div className="w-full md:w-[60%] md:mr-3 lg:mr-0 ml-3 md:ml-0 space-y-10 flex flex-col justify-center">
                        <div className="flex w-full items-center">
                            <h3 className="font-semibold md:text-xl mr-9">បន្ទប់: </h3>
                            <div className="bg-white px-4 pt-2 md:pt-3 pb-0.5 md:py-5 border-2 items-center rounded-lg shadow-custom-shadow mx-0 w-[100%] text-xl font-semibold">
                                {room}
                            </div>
                        </div>
                        <div className="flex w-full items-center">
                            <h3 className="font-semibold md:text-xl mr-5">ទិន្នន័យ: </h3>
                            <div className="bg-white px-4 pt-2 md:pt-3 pb-0.5 md:py-5 border-2 items-center rounded-lg shadow-custom-shadow mx-0 w-[100%] text-xl font-semibold">
                                {Number(amountInput).toLocaleString('en-US') || 0}
                            </div>
                        </div> 
                    </div>
                </div>

                {/* Information Section */}
                <div className="flex flex-col lg:flex-row w-[90%] md:w-[70%] mb-6">
                    {/* Button Section */}
                    <div className="flex items-center w-full justify-center lg:w-full">
                        <div className="w-full">
                            {/* Keypad grid */}
                            <div className="grid grid-cols-3 gap-3 w-full">
                                {/* Number buttons */}
                                {['7', '8', '9', '4', '5', '6', '1', '2', '3', '00', '0'].map((num) => (
                                <button
                                    key={num}
                                    onClick={() => handleButtonClick(num)}
                                    className="py-4 text-2xl bg-white border rounded shadow font-semibold"
                                >
                                    {num}
                                </button>
                                ))}

                                <button
                                    onClick={handleDelete}
                                    className="p-4 text-lg bg-white border rounded shadow"
                                >
                                {/* Backspace button */}
                                ←
                                </button>
                            </div>
                        </div>
                    </div> 
                </div>

                {/* Action buttons */}
                <div className="flex flex-col md:flex-row w-full md:justify-center">
                    <div className="flex justify-center mb-5 md:mb-0">
                        <button
                            type="button"
                            onClick={() => {handleArrowChangeRoom("backward")}}
                            className="px-6 py-1 md:py-4 text-lg md:text-2xl font-medium  text-gray-800 rounded-lg hover:bg-gray-200 mr-4"
                        >
                            ← ទៅបន្ទប់មុន
                        </button>
                        <button
                            type="submit"
                            className="px-6 py-1 md:py-4 text-lg md:text-2xl font-medium rounded-lg hover:bg-gray-200 md:mr-40"
                            onClick={() => {handleArrowChangeRoom("forward")}}
                        >
                            ទៅបន្ទប់បន្ទាប់ →
                        </button>
                    </div>
                    <div className="flex justify-center">
                        <button
                            type="submit"
                            className="flex items-center px-20 md:px-24 py-1 md:py-4 text-lg md:text-2xl font-medium bg-secondary1 text-white  rounded-lg hover:bg-primary2"
                            onClick={handleDataSubmit}
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6 mr-3">
                                <path strokeLinecap="round" strokeLinejoin="round" d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
                            </svg>
                            បញ្ចូល
                        </button>
                    </div>
                </div>
                    {alertVisible && (
                    <Stack sx={{ width: '100%', justifyContent: "flex-end",
                        alignItems: "flex-end"}}  mt={-5} spacing={2} borderRadius={2}>
                        <Alert severity={alertSeverity} sx={{fontWeight: 500, fontSize: '16px'}}>
                            {alertMessage}
                        </Alert>
                    </Stack>
                )}
            </div>)}
            {/* Alert */}
            {/* Dialog for Validation */}
            <Dialog open={openDialog} onClose={handleDialogClose}>
                <DialogTitle sx={{ fontFamily: "'Kantumruy Pro', sans-serif", fontSize: '24px' }} color="#c50000">ការព្រមាន</DialogTitle>
                <DialogContent>
                    {roomNotFoundError ? ( 
                    <DialogContentText sx={{ fontFamily: "'Kantumruy Pro', sans-serif", fontSize: '20px' }}>
                        {roomNotFoundError}
                    </DialogContentText>):
                    (
                        <DialogContentText sx={{ fontFamily: "'Kantumruy Pro', sans-serif", fontSize: '20px' }}>
                            សូមជ្រើសរើសអគារ និងបន្ទប់
                        </DialogContentText>
                    )
                    }
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleDialogClose} color="primary"  sx={{ fontFamily: "'Inter', sans-serif", fontSize: '20px' }}>
                    OK
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    )
}